module.exports = __webpack_public_path__ + "c31f4515d833e7bf3159f8653443a322.svg";